import React from 'react'
import Footer from '../Component/Footer';
import Header from '../Component/Header';
function Error (){
    return (
		<div>
		<Header />
        <div id="notfound">
		<div class="notfound">
			<div class="notfound-404">
				<h1>Oops!</h1>
			</div>
			<h2>Page unavailable</h2>
			<p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
			<a href="/">Go To Homepage</a>
		</div>
	</div>
	<Footer />
	</div>
    )
}
export default Error;
